/*
 * giftCardHelpers.js — gift card lines of the WebPOS shopping cart.
 *
 * A gift card line sells one voucher (itemTypeData.giftCardVoucherId / giftCardVoucherCode),
 * so its quantity is always 1 and the same gift card can be in the cart only once.
 */

export function isGiftCardItem(itemTypeData) {
  return itemTypeData?.giftCardVoucherId > 0;
}

export function isSameGiftCard(itemTypeData, giftCardVoucherId, giftCardVoucherCode) {
  if (!isGiftCardItem(itemTypeData)) {
    return false;
  }
  return itemTypeData.giftCardVoucherId === giftCardVoucherId
    || (!!giftCardVoucherCode && itemTypeData.giftCardVoucherCode?.toUpperCase() === giftCardVoucherCode.toUpperCase());
}

export function findGiftCardInCart(items, giftCardVoucherId, giftCardVoucherCode) {
  return (items || []).find(item => isSameGiftCard(item.itemTypeData, giftCardVoucherId, giftCardVoucherCode));
}
